import template from './anonymous_survey_setup_help.html';
import * as Utils from '../../../lib/savanna_utils.js';

class AnonymousSurveySetupHelpViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
	};

	close()
	{
		this.dialog.close();
	}
};

class AnonymousSurveySetupHelpPage
{
	constructor (bindings)
	{
		this.viewModel = new AnonymousSurveySetupHelpViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		Utils.refresh_data_visible_roles();
	}
};

export default
{
	name: 'AnonymousSurveySetupHelp',
	dialog_class: AnonymousSurveySetupHelpPage,
	template: template,
	template_filename: 'translation/dialogs/anonymous_survey_setup_help',
	provider: 'ps'
};
